module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-test-yourself-large.a07b57b3.png";